import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./pricesection.css";

function PricingSection() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration (1s)
      once: true,     // animation runs only once
      easing: "ease-out",
    });
  }, []);

  const handleCall = () => {
    window.location.href = "tel:8778934301"; // opens phone dialer
  };


  const plans = [
    {
      title: "Startup Plan",
      price: "₹5,999/-",
      subtitle: "Best For Startup's",
      features: [
        "4 Page Modern Website",
        "Dynamic Website",
        "Domain Configuration",
        "Hosting Configuration",
        "2 Business Emails",
        "Responsive Design (Mobile & Tablet Friendly)",
        "Basic SEO Setup",
        "SSL Certificate",
        "1 Month Support & Maintenance",
        "Google Analytics Integration",
        "Speed Optimization (Basic)",
        "Favicon & Branding Setup",
        "Contact Form / Lead Form",
        "Social Media Links Integration",
        "Basic Security Features (Firewall, Malware Scan)",
      ],
    },
    {
      title: "Classic Plan",
      price: "₹9,999/-",
      subtitle: "Best For Small / Medium Business",
      popular: true,
      features: [
        "8 Page Modern Website",
        "Dynamic Website",
        "Domain Configuration",
        "Hosting Configuration",
        "3 Business Emails",
        "Responsive Design (Mobile & Tablet Friendly)",
        "Advanced SEO Setup",
        "SSL Certificate",
        "3 Months Support & Maintenance",
        "Google Analytics Integration",
        "Social Media Integration",
        "Contact Form / Lead Generation Form",
        "Speed Optimization (Advanced)",
        "Blog / News Section",
        "Image & Video Gallery",
        "Security Enhancements (Firewall, Anti-Spam, Malware Scan)",
        "Basic Marketing Tools (Newsletter, Popup Forms)",
      ],
    },
    {
      title: "Premium Plan",
      price: "₹11,999/-",
      subtitle: "Best For Enterprises",
      features: [
        "12 Page Modern Website",
        "Dynamic Website",
        "Domain Configuration",
        "Hosting Configuration",
        "5 Business Emails",
        "Responsive Design (Mobile & Tablet Friendly)",
        "Premium SEO Setup",
        "SSL Certificate",
        "6 Months Support & Maintenance",
        "Google Analytics Integration",
        "Social Media Integration",
        "E-Commerce / Payment Gateway Integration",
        "Blog / News Section",
        "Live Chat Integration",
        "Speed Optimization (Premium)",
        "Advanced Security (Firewall, DDoS Protection, Malware Scan)",
        "Marketing Tools Integration (Email Campaigns, Popups, CTAs)",
        "Custom Design Animations & Interactive Elements",
        "Content Management System (CMS) Access",
      ],
    },
    {
      title: "Custom Plan",
      price: "₹ ???",
      subtitle: "Best For Custom Website",
      features: [
        "Pages: As Per Requirement",
        "Dynamic Website",
        "Domain Configuration",
        "Hosting Configuration",
        "5 Business Emails",
        "Responsive Design (Mobile & Tablet Friendly)",
        "Custom SEO & Marketing Tools",
        "SSL Certificate",
        "Custom Support & Maintenance Plan",
        "Google Analytics Integration",
        "Social Media Integration",
        "Custom Features as Requested (E-Commerce, CRM, Chatbots, etc.)",
        "Custom Security Setup",
        "Speed Optimization Customized",
        "Custom Integrations (APIs, Payment Gateways, Third-party Tools)",
        "Branding & UI/UX Custom Design",
        "Interactive Animations & Advanced Functionality",
        "Custom Marketing & Automation Setup",
      ],
    },
  ];

  return (
    <section id="services" className="servicess-section">
    <section className="pricing-section">
      <div className="container">
        <section className="section-margin">
          <div className="heading-for-all"  data-aos="fade-up">
            <h2>Start-Up & Business Website</h2>
          </div>
        </section>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? "popular" : ""}`}
              data-aos="fade-up"
              data-aos-delay={index * 150} // slight delay for staggered effect
            >
              {plan.popular && <div className="popular-badge">POPULAR</div>}
              <h3 className="plan-title">{plan.title}</h3>
              <p className="plan-price">{plan.price}</p>
              <p className="plan-subtitle">{plan.subtitle}</p>
              <ul className="plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i}>✅ {feature}</li>
                ))}
              </ul>
              <button className="choose-plan-btn"  onClick={handleCall}>Choose Plan</button>
            </div>
          ))}
        </div>
      </div>
    </section>
    </section>
  );
}

export default PricingSection;
